// removed by extract-text-webpack-plugin
module.exports = {"term_text":"_2BuIZpX3tVpYYHG4Jzkn2v","signup_form":"_1QpUWpqs2miX4qHCwTawJ_","photography_form":"_2d9-pCv4izqSoMX4olApLK","input":"_3KFOOeGwObn5TYAwD9rptq","forgot":"_1SoJSpht5jw5HkyY8WZioi","button":"VtM2plqfivXNOj6Z0QcMC","footer":"byjMHixpqCnvUFOfyA8H4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/Signup/signup.css
// module id = 3055
// module chunks = 0